import * as Types                           from '../../actions/types/view-elements';
import { createReducer }                    from 'redux-immutablejs';
import Immutable                            from 'immutable';

const initial = Immutable.fromJS({
    toasts      : [],
    modals      : [],
});

const viewElements =  createReducer(initial, {
    [Types.CREATE_NEW_MODAL]: (state, action) => 
        state.mergeDeep({
            modals: [ ...state.get('modals'), action.payload ]
        }),
    [Types.REMOVE_MODAL]: (state, action) => 
        state.merge({
            modals: [ ...state.get('modals').filter(o => o !== action.payload) ]
        }),
    [Types.CREATE_NEW_TOAST]: (state, action) => 
        state.mergeDeep({
            toasts: [ ...state.get('toasts'), action.payload ]
        }),
    [Types.REMOVE_TOAST]: (state, action) => 
        state.merge({
            toasts: [ ...state.get('toasts').filter(o => o !== action.payload) ]
        })
});

export default viewElements;